import * as React from 'react';
import { useEffect, useState } from 'react';
import { useCartStore } from "../../../hooks/cart";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useQuoteDetailStore } from 'src/hooks/quote-detail';
import Cart from 'src/model/Cart';
import System from 'src/helper/system';

const CartShippingAddress = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [onChangeValue, setOnChangeValue] = useState(false);
    const [{ CART_SHIPPING_ADDRESS_ID, SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE, SHIPPING_ADDRESS_LIST, CART_DATA, QUOTE_CART_BLACKLISTED_ARR }, { get_Mfr_code_validate_to_ship, shipping_address_list, get_cart_quote_number, check_item_blacklist_country }, { shipping_address_id, SET_SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE, SET_SELECTED_SHIPPING_ADDRESS }] = useCartStore();

    const [{ get_current_quote_cart }, { }, { }] = useQuoteDetailStore();
    const quoteList = get_current_quote_cart();
    const quoteNumber = get_cart_quote_number();

    const [isDisplayList, setIsDisplayList] = useState(false); // It is taken for show hide address DDL

    const getShippingAddressDisplayStatus = () => {
        if (quoteNumber) {
            return quoteList && Object.entries(quoteList).length > 0;
        }
        else {
            /**
             * Ticket #  : 9860
             * Change #  : Shipping Address dropdown will show everytime even if part is not available
             * Change by : Pankaj
             * Date      : 24 April 2023 
             */
            return CART_DATA &&
                Object.entries(CART_DATA).length > 0 &&
                CART_DATA.length > 0;
        }
    };

    // Open this for not rerender the ddl & remove this !__check(['CART_API_CALL']).status && from function
    useEffect(() => {
        // if (isDisplayList === false) {
        setIsDisplayList(getShippingAddressDisplayStatus())
        // }
        // 16231 - Quote Cart separate api for validating black list items from cart - PN - 24-4-2024
        // if(quoteList && Object.entries(quoteList)?.length > 0)        
        // {
        //     async function fetchHere() {
        //         let reqObj = Object.entries(quoteList).map((x) => {
        //             return {
        //                 "manufacturerCode": x[1]?.product?.ERPManufacturerCode,
        //                 "vendorCode": x[1]?.product?.VendorCode,
        //                 "sapMatGroup": x[1]?.product?.SAPMatgroup,
        //                 "partNumber": x[1]?.product?.ERPPartNumber
        //             }
        //         });
        //         await check_item_blacklist_country(reqObj);
        //     }
        //    fetchHere();
        // }
    }, [CART_DATA, quoteList]);


    // useEffect(() => {
    //     if(QUOTE_CART_BLACKLISTED_ARR && QUOTE_CART_BLACKLISTED_ARR?.length > 0 &&
    //         QUOTE_CART_BLACKLISTED_ARR?.filter(x => x?.isVendorExcluded === true).length > 0)
    //     {
    //         System.alert("The part(s) in your cart are not eligible. Please remove them to proceed to Checkout.","warning")
    //     }
    // }, [QUOTE_CART_BLACKLISTED_ARR])

    useEffect(() => {
        if (SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE && SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE !== undefined) {
            get_Mfr_code_validate_to_ship(SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE);
        }
    }, [SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE]);

    useEffect(() => {
        if (quoteNumber && quoteNumber !== undefined && SHIPPING_ADDRESS_LIST && SHIPPING_ADDRESS_LIST?.length > 0 && CART_SHIPPING_ADDRESS_ID && CART_SHIPPING_ADDRESS_ID !== undefined && CART_SHIPPING_ADDRESS_ID !== " " && CART_SHIPPING_ADDRESS_ID !== null) {
            const countryCode = ((SHIPPING_ADDRESS_LIST).find(f => f.shipToAddressId === CART_SHIPPING_ADDRESS_ID)).countryCode;
            if (countryCode) {
                SET_SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE(countryCode);
            }
        }
        SET_SELECTED_SHIPPING_ADDRESS(SHIPPING_ADDRESS_LIST, CART_SHIPPING_ADDRESS_ID)
    }, [SHIPPING_ADDRESS_LIST, CART_SHIPPING_ADDRESS_ID]);

    useEffect(() => {
        if (SHIPPING_ADDRESS_LIST && SHIPPING_ADDRESS_LIST.length > 0) {
            const index = SHIPPING_ADDRESS_LIST?.findIndex(v => v.isDefault);
            if (index >= 0) {
                const { shipToAddressId } = SHIPPING_ADDRESS_LIST[index];
                new Cart().setCartShippingAddress({
                    CART_SHIPPING_ADDRESS_ID: shipToAddressId
                });
            }
        }

    }, [SHIPPING_ADDRESS_LIST])

    useEffect(() => {
        async function fetchHere() {
            await shipping_address_list();
        }
        setTimeout(() => {
            fetchHere()
        }, 1200);
    }, []);

    const onChangeAddress = async (e, v) => {
        if (props.onChangeCallBack !== undefined) {
            props.onChangeCallBack(v.countryCode);
            setOnChangeValue(v.shipToAddressId);
        }
        $('#shippingAddressDropDown').removeClass('open'); //  close dropdown after selection
        await shipping_address_id(v.shipToAddressId)
    }

    return (
        <>
            <div className="bs5 row mt-1">
                <div className="col-auto">
                    {quoteNumber ? <h1 aria-label="Quote Cart Summary" className='main-title'>Quote Cart Summary</h1> : <h1 aria-label="My Cart" className='main-title'>My Cart</h1>}
                </div>
                {isDisplayList &&
                    <div className="col-auto ms-auto align-self-end">
                        {CART_SHIPPING_ADDRESS_ID && 'Ship to Address'}
                        <div id={'shippingAddressDropDown'} className="dropdown selectbox">
                            <a className="bs5 form-control form-control-sm text-black dropdown-control w290 my-cart-address-select"
                                data-toggle="dropdown" aria-expanded="false" id="Customer"
                            >
                                <span>{SHIPPING_ADDRESS_LIST !== undefined &&
                                    SHIPPING_ADDRESS_LIST.length > 0 &&
                                    SHIPPING_ADDRESS_LIST.map((v) => (
                                        <React.Fragment
                                            key={v.shipToAddressId}>{(v.shipToAddressId === CART_SHIPPING_ADDRESS_ID || onChangeValue === v.shipToAddressId) &&
                                                <>
                                                    {v.name && v.name.trim() !== '' ? v.name + ', ' : ''} {v.addressLine && v.addressLine.trim() !== '' ? v.addressLine + ', ' : ''}
                                                    {v.postalCode && v.postalCode.trim() !== '' ? v.postalCode + ', ' : ''} {v.countrySubDivisionCode && v.countrySubDivisionCode.trim() !== '' ? v.countrySubDivisionCode + ', ' : ''}
                                                    {v.cityName && v.cityName.trim() !== '' ? v.cityName + ', ' : ''} {v.countryCode && v.countryCode.trim() !== '' ? v.countryCode : ''}
                                                </>
                                            }
                                        </React.Fragment>
                                    ))
                                }
                                    {!CART_SHIPPING_ADDRESS_ID &&
                                        <>Select Shipping Address</>
                                    }</span>
                            </a>
                            <ul className="dropdown-menu dropdown-menu-right" aria-label="dropdownMenuButton1">
                                {SHIPPING_ADDRESS_LIST !== undefined && SHIPPING_ADDRESS_LIST.length > 0 &&
                                    SHIPPING_ADDRESS_LIST.map((v) => (
                                        <li key={v.shipToAddressId} value={v.shipToAddressId}
                                            onClick={async (e) => {
                                                await onChangeAddress(e, v);
                                            }}
                                        >
                                            <a href={void (0)} className={`dropdown-item text-black`}>
                                                <p style={{ fontWeight: (v.shipToAddressId === CART_SHIPPING_ADDRESS_ID || onChangeValue === v.shipToAddressId) && "bold" }} >
                                                    {v.name && v.name.trim() !== '' ? v.name + ', ' : ''} {v.addressLine && v.addressLine.trim() !== '' ? v.addressLine + ', ' : ''}
                                                    {v.postalCode && v.postalCode.trim() !== '' ? v.postalCode + ', ' : ''} {v.countrySubDivisionCode && v.countrySubDivisionCode.trim() !== '' ? v.countrySubDivisionCode + ', ' : ''}
                                                    {v.cityName && v.cityName.trim() !== '' ? v.cityName + ', ' : ''} {v.countryCode && v.countryCode.trim() !== '' ? v.countryCode : ''}
                                                </p>
                                            </a>
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    </div>
                }
            </div>
        </>
    );
}

export default CartShippingAddress;